import React from "react";
import { Container, Row, Col } from 'reactstrap'
function Links() {
  return (
    <div className="section section-gray">
      <div className="features-1" id="links">
        <Container>
          <Row>
            <Col className="ml-auto mr-auto text-left" md="8">
              <h2 className="title text-center">Links</h2>
              <ul>
                <li className="pl-3"><a href="http://www.turismohualaihue.cl">Turismo Hualaihué</a></li>
                <li className="pl-3"><a href="https://www.facebook.com/1889099497802604/posts/3487387807973757/">Ruta de los parques de la patagonia</a></li>
                <li className="pl-3"><a href="https://laderasur.com/articulo/marsupiales-chilenos-conoce-estos-pequenos-primitivos-y-excepcionales-mamiferos/">Ladera Sur - Marsupiales Chilenos</a></li>
                <li className="pl-3"><a href="https://edition.cnn.com/2020/07/15/world/vreni-haussermann-c2e-spc-scn-int/index.html">CNN - The wild deep: Discovering new species in Chilean Patagonia </a></li>
                <li className="pl-3"><a href="https://www.tripadvisor.cl/Attractions-g317796-Activities-Chaiten_Los_Lagos_Region.html">Tripadvisor</a></li>
                <li className="pl-3"><a href="http://www.municipalidadhualaihue.cl/">Municipalidad de Hualaihué</a></li>
                <li className="pl-3"><a href="https://patagoniaverde.org/">Patagonia Verde</a></li>
                <li className="pl-3"><a href="https://issuu.com/latejuela/docs/mirostrounamira">Mi rostro, una mirada</a></li>
                <li className="pl-3"><a href="https://patagoniaverde.org/web/wp-content/uploads/2020/04/Catalogo_Patagonia_Verde_baja.pdf">Catálogo Patagonia Verde Artesanías</a></li>
                <li className="pl-3"><a href="http://memoriafotograficahualaihue.cl/">Memoria fotográfica Hualaihué</a></li>

                <li className="pl-3"><a href="http://memoriafotograficahualaihue.cl/descargas/">Profesor en línea</a></li>
                  <li className="pl-3"><a href="https://youtu.be/Ux4fvcb7gp4">Youtube - El Golfo Corcovado: ecosistema único para ballenas azules en Chile</a></li>
                  <li className="pl-3"><a href="https://youtu.be/eyPIeZ6x4j4">Youtube - AUSTRALEX Kayak. Río Chiñihue.Chaitén</a></li>
                  <li className="pl-3"><a href="https://youtu.be/TVZ2riVVppk">Youtube - Kayak Chili - Chaitén - Salto Pumalín</a></li>
                  <li className="pl-3"><a href="https://www.youtube.com/watch?v=0ag94doNih0">Youtube - Lugares que Hablan / Futaleufú, Naturaleza Imponente</a></li>
                  <li className="pl-3"><a href="https://www.13.cl/programas/lugares-que-hablan/temporada-2017/lugares-que-hablan-chaiten-naturaleza-indomita">C13 - Lugares que hablan</a></li>
                  <li className="pl-3"><a href="https://www.youtube.com/watch?v=6_OFXBK37gs">Youtube - DW - Rumbo al corazón de la Patagonia | DW Documental</a> </li>
                  <li className="pl-3"><a href="https://www.youtube.com/watch?v=sPxoZ0bLgVg">Youtube - Capítulo 5 | Lugares Que Hablan | Temporada 2018</a></li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}
export default Links

